import { useCallback } from 'react'
import { useAppDispatch } from './reduxHooks'
import { pushWithRegion } from 'actions/NavigationActions'

export default function useNavigateTo() {
  const dispatch = useAppDispatch()
  return useCallback((path: string, search?: string) => dispatch(pushWithRegion(path, search)), [dispatch])
}
